var map = {
	"./decidim/avatar-multiuser.png": 2340,
	"./decidim/brands/google.svg": 640,
	"./decidim/cc-badge.png": 8042,
	"./decidim/decidim-logo.svg": 6085,
	"./decidim/default-avatar.svg": 3139,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 3500,
	"./decidim/icons.svg": 8889,
	"./decidim/pattern.png": 7749,
	"./decidim/placeholder-card-g.svg": 6920,
	"./decidim/placeholder-card-l.svg": 4231,
	"./decidim/placeholder.jpg": 7924,
	"./decidim/remixicon.symbol.svg": 1838,
	"./decidim/vendor/leaflet/layers-2x.png": 190,
	"./decidim/vendor/leaflet/layers.png": 778,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 4840,
	"./decidim/vendor/leaflet/marker-icon.png": 2579,
	"./decidim/vendor/leaflet/marker-shadow.png": 4133,
	"./decidim/vendor/social-share-button/douban.svg": 1186,
	"./decidim/vendor/social-share-button/email.svg": 8189,
	"./decidim/vendor/social-share-button/facebook.svg": 7107,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 9312,
	"./decidim/vendor/social-share-button/hacker_news.svg": 2188,
	"./decidim/vendor/social-share-button/linkedin.svg": 9739,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 9384,
	"./decidim/vendor/social-share-button/pinterest.svg": 4766,
	"./decidim/vendor/social-share-button/reddit.svg": 2433,
	"./decidim/vendor/social-share-button/telegram.svg": 1444,
	"./decidim/vendor/social-share-button/tumblr.svg": 2253,
	"./decidim/vendor/social-share-button/twitter.svg": 2938,
	"./decidim/vendor/social-share-button/vkontakte.svg": 7832,
	"./decidim/vendor/social-share-button/wechat.svg": 7476,
	"./decidim/vendor/social-share-button/whatsapp.svg": 2291,
	"./decidim/vendor/social-share-button/x.svg": 455,
	"./decidim/vendor/social-share-button/xing.svg": 2328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4755;